import styled from 'styled-components'
import get from 'lodash/get'
import i18n from 'i18n-client'

const getChildren = props => props.children || i18n.t('optional')
const getFontFamily = props => get(props, 'theme.field.optional.family', 'inherit')
const getFontWeight = props => get(props, 'theme.field.optional.weight', 'inherit')
const getColor = props => get(props, 'theme.field.optional.color', 'inherit')
const getFontSize = props => get(props, 'theme.field.optional.fontSize', '14px')
const getLineHeight = props => get(props, 'theme.field.optional.lineHeight', '20px')

const Optional = styled.span.attrs(props => ({children: getChildren(props)}))`
  margin-left: ${props => (props.withMargin ? '12px' : '0px')};
  font-size: ${getFontSize};
  line-height: ${getLineHeight};
  font-family: ${getFontFamily};
  font-weight: ${getFontWeight};
  color: ${getColor};
`

export default Optional
